/**
 * True when `code` is exactly `family` or a subcategory of it (e.g. R4, R4-2).
 * Does not treat R10 as R1 (`startsWith('R1')` would).
 */
export const matchesCategoryFamily = (
  code: string | null | undefined,
  family: string,
): boolean => {
  if (!code) return false
  const upper = code.trim().toUpperCase()
  const fam = family.trim().toUpperCase()
  if (!fam) return false
  return upper === fam || upper.startsWith(`${fam}-`)
}

export const matchesAnyCategoryFamily = (
  code: string | null | undefined,
  families: readonly string[],
): boolean => families.some((family) => matchesCategoryFamily(code, family))

/** R1 chain slings and R3 wire slings. */
export const isSlingCategory = (code: string | null | undefined): boolean =>
  matchesAnyCategoryFamily(code, ['R1', 'R3'])
